import { CoreService } from "./core-service";

export class CoreSignupInfoService extends CoreService
{
    needsToken = ()=> false;
    getBaseUrl = ()=> `https://dev.best-experiences.com/invitation-signup-info/api/new-vendors-portal`;
    getSignupInfoUrl = (id, guid)=> `${this.getBaseUrl()}/invitation-info/${id}/${guid}`;

    getVendorSignupUrl = (dealId, vendorId)=> `${this.getBaseUrl()}/vendor-signup/${dealId}/${vendorId}`;

    getApiKey = ()=> 'x';

    getSignupInfo = async (id, guid)=>{
        const result = await this.callWebApi('GET', this.getSignupInfoUrl(id, guid), null);
        return result.data;
    }

    getVendorSignupInfo = async (dealId, vendorId, captchaToken)=>{
        const extraHeaders = captchaToken ? { captchaToken } : {};
        const url = this.getVendorSignupUrl(dealId, vendorId);
        console.log('Requesting vendor signup info with URL:', url);
        const result = await this.callWebApi('GET', url, null, null, extraHeaders);
        return result.data;
    }

    postVendorSignup = async (dealId, vendorId, data, captchaToken)=>{
        const extraHeaders = captchaToken ? { captchaToken } : {};
        const url = this.getVendorSignupUrl(dealId, vendorId);
        const result = await this.callWebApi('POST', url, data, null, extraHeaders);
        return result.data;
    }

}